import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { AzureSqlSink } from 'app/model/pipeline/copysink/azure-sql.copysink';
import { sqlSinkAdapts, SqlSinkAdapter } from './sql.sink.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureSqlSink),
    asynchronous: true,
    adapts: sqlSinkAdapts
})
export class AzureSqlSinkAdapter extends SqlSinkAdapter {
}
